export default "__VITE_ASSET__CRJKdngg__"